import _ from 'lodash';
import * as consts from '../constants';
import commonFunctions from '../commonFunctions';

class emissionApi {

    static loadContracts(token, searchModel) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/contract/filtered';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nel caricamento dello Storico Adesioni!');
                    }
                }
            };
            req.send(JSON.stringify(searchModel));
        });
    }

    static contractsExport(token, filers) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/contract/exportFiltered';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(filers));
        });
    }

    static createProposal(token, contract) {
        return new Promise((resolve, reject) => {
            if (_.toNumber(contract.personType) === consts.GENERIC_ENUM.personType[0].value) {
                var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/createProposal', 'POST');
                req.onreadystatechange = function () {
                    if (req.readyState === 4) {
                        if (req.status >= 200 && req.status < 400) {
                            resolve(JSON.parse(req.response));
                        } else if (req.status === 400) {
                            try {
                                if (parseInt(JSON.parse(req.response).message, 10) >= 0)
                                    reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                                else
                                    reject(JSON.parse(req.response).message);
                            } catch (err) {
                                reject(JSON.parse(req.response).message);
                            }
                        } else if (req.status === 401 || req.status === 403) {
                            reject('Non sei autorizzato o la sessione è scaduta');
                        } else {
                            reject('Errore sul server!');
                        }
                    }
                };
                req.send(JSON.stringify(contract));
            } else {
                var xhr = new XMLHttpRequest();
                xhr.open('POST', process.env.REACT_APP_BASE_URL + '/api/contract/createProposalPG/', true);
                xhr.setRequestHeader('Content-Length', contract.personaGiuridica.fileBenificiari.size);
                xhr.setRequestHeader('X-Token', token);

                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        if (xhr.status >= 200 && xhr.status < 400) {
                            resolve(JSON.parse(xhr.response));
                        } else if (xhr.status === 400) {
                            try {
                                if (parseInt(JSON.parse(xhr.response).message, 10) >= 0)
                                    reject(commonFunctions.errorMessage(JSON.parse(xhr.response).message));
                                else
                                    reject(JSON.parse(xhr.response).message);
                            } catch (err) {
                                reject(JSON.parse(xhr.response).message);
                            }
                        } else if (xhr.status === 401 || xhr.status === 403) {
                            reject('Non sei autorizzato o la sessione è scaduta');
                        } else {
                            reject('Errore sul server nel caricamento del Contratto!');
                        }
                    }
                };
                var formData = new FormData();
                formData.append('model', JSON.stringify(contract));
                formData.append('pgFile', contract.personaGiuridica.fileBenificiari);
                xhr.send(formData);
            }
        });
    }

    static newDatiPagamentoForProposta(token, contract) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/newDatiPagamentoForProposta', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        try {
                            reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                        } catch (err) {
                            reject(JSON.parse(req.response).message);
                        }
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(contract));
        });
    }

    static newNoteAggiuntiveForProposta(token, contract) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/newNoteAggiuntiveForProposta', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(contract));
        });
    }

    static saveNoteNonStampate(token, contract) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/saveNoteNonStampate', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(contract));
        });
    }

    static deleteContract(token, contractId) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/deleteContract/' + contractId, 'DELETE');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static cofermaPreventivo(token, contract) {
        return new Promise((resolve, reject) => {
            let method = 'POST';
            if (contract.id > -1)
                method = 'PUT';

            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/cofermaPreventivo', method);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(contract));
        });
    }

    static createAdesione(token, contract, targetDate) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/createAdesione', 'PUT');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify({ contract: contract, targetDate: targetDate }));
        });
    }

    static payAccountPeriod(token, accountperiodId, targetDate) {
        return new Promise((resolve, reject) => {
            const method = 'PUT';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/payAccountPeriod/', method);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify({ accountperiodId, targetDate }));
        });
    }

    static cancelAccountPeriod(token, accountperiodId) {
        return new Promise((resolve, reject) => {
            const method = 'PUT';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/cancelAccountPeriod/', method);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify({ accountperiodId }));
        });
    }

    static renewContract(token, contractId, targetDate, productId, instalmentMode) {
        return new Promise((resolve, reject) => {
            const method = 'PUT';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/renew/', method);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 406) {
                        reject('Il prodotto scelto non è compatibile');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify({ contractId, targetDate, productId, instalmentMode }));
        });
    }

    static cancelRenewContract(token, contractId) {
        return new Promise((resolve, reject) => {
            const method = 'DELETE';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/renew/' + contractId, method);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 406) {
                        reject('Il prodotto scelto non è compatibile');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static closeContract(token, contractId, targetDate, closeAtTheEnd) {
        return new Promise((resolve, reject) => {
            const method = 'PUT';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/close/', method);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify({ contractId, targetDate, closeAtTheEnd }));
        });
    }

    static productsForRenew(token, contractId) {
        return new Promise((resolve, reject) => {
            const method = 'GET';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/productsForRenew/' + contractId, method);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static loadContract(token, id) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/get/' + id, 'GET');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nel caricamento del Contratto!');
                    }
                }
            };
            req.send();
        });
    }

    static stampaCertificatoAdesioneDipendente(token, id) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/stampaCertificatoAdesioneDipendente/' + id, 'GET');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static inviaLetteraDiBenvutoDipendente(token, id) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/inviaLetteraDiBenvutoDipendente/' + id, 'GET');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        const resJ = JSON.parse(req.response)
                        reject(resJ.message);
                    }  else {
                        reject('Problemi nell\'invio della Lettera di Benvenuto del Dipendente');
                    }
                }
            };
            req.send();
        });
    }

    static generaModuliPropostaDipendenti(token, printPrice, contractId) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/generaModuliPropostaDipendenti/', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nella generazione dei Moduli!');
                    }
                }
            };
            req.send(JSON.stringify({ contractId, printPrice }));
        });
    }

    static generaCertificatiAdesioneDipendenti(token, contractId) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/generaCertificatiAdesioneDipendenti/', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nella generazione dei Certificati di Adesione!');
                    }
                }
            };
            req.send(JSON.stringify({ contractId }));
        });
    }

    static loadPGUsers(token, id, file, startDate) {
        return new Promise((resolve, reject) => {
            var xhr = new XMLHttpRequest();

            var url = process.env.REACT_APP_BASE_URL + '/api/contract/loadPgUsers/' + id;
            if (!_.isNil(startDate))
                url = url + '?startDate=' + startDate;

            xhr.open('POST', url, true);
            xhr.setRequestHeader('Content-Length', file.size);
            xhr.setRequestHeader('X-Token', token);

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status >= 200 && xhr.status < 400) {
                        resolve(JSON.parse(xhr.response));
                    } else if (xhr.status === 400) {
                        reject(JSON.parse(xhr.response).message);
                    } else if (xhr.status === 401 || xhr.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nel caricamento del Contratto!');
                    }
                }
            };
            var formData = new FormData();
            formData.append('pgFile', file);
            xhr.send(formData);
        });
    }

    static filePersonaleLoad(token, id, file, documentPersonaleType) {
        return new Promise((resolve, reject) => {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', process.env.REACT_APP_BASE_URL + '/api/contract/filePersonaleLoad/' + id + '?documentType=' + documentPersonaleType, true);
            xhr.setRequestHeader('Content-Length', file.size);
            xhr.setRequestHeader('X-Token', token);

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status >= 200 && xhr.status < 400) {
                        resolve(JSON.parse(xhr.response));
                    } else if (xhr.status === 400) {
                        reject('Attenzione stai cercando di caricare un file di un formato non consentito, o di dimensione troppo elevata (MAX 130MB)');
                    } else if (xhr.status === 401 || xhr.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nel caricamento del Contratto!');
                    }
                }
            };
            var formData = new FormData();
            formData.append('pgFile', file);
            xhr.send(formData);
        });
    }

    static filePersonaleDelete(token, documentId) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/filePersonaleDelete/' + documentId, 'DELETE');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(JSON.parse(req.response).message);
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static chiudiCoperturaMembro(token, contractMemberId, targetDate, familiare) {
        if (_.isNil(familiare))
            familiare = {};

        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/chiudiCoperturaMembro', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nella chiusura della Copertura!');
                    }
                }
            };
            req.send(JSON.stringify({
                targetDate,
                contractMemberId,
                familiare
            }));
        });
    }

    static addFamiliare(token, contractId, familiare) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/addFamiliare/', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        try {
                            var appRes = JSON.parse(req.response);
                            if (appRes.message)
                                reject(appRes.message);
                            else
                                reject('Attenzione la richiesta formulata è errata');
                        } catch (err) {
                            reject('Attenzione la richiesta formulata è errata');
                        }

                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nella aggiunta del Familiare!');
                    }
                }
            };
            req.send(JSON.stringify({ contractId, familiare }));
        });
    }

    static notificaProssimaScadenza(token, contractId) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/contract/notificaProssimaScadenza/' + contractId;
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify());
        });
    }

    static exportBeneficiari(token, contractId) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/contract/exportBeneficiari/' + contractId;
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'GET');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        var ret = JSON.parse(req.response);
                        commonFunctions.saveFile(ret.base64, ret.fileName, ret.contentType);
                        resolve();
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static getCertificazioniIncassi(token, contractId) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/contract/getCertificazioniIncassi?contractId=' + contractId;

            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'GET');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nel caricamento dello Storico Adesioni!');
                    }
                }
            };
            req.send();
        });
    }

    // ********************************************************************************************************************************************
    //                                          Piano Flex
    // ********************************************************************************************************************************************
    static pianoFlexRenewContract(token, contractId, targetDate, instalmentMode, pianoFlex) {
        return new Promise((resolve, reject) => {
            const method = 'PUT';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/contract/pianoFlexRenew/', method);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 406) {
                        reject('Il prodotto scelto non è compatibile');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify({ contractId, targetDate, instalmentMode, pianoFlex }));
        });
    }
}

export default emissionApi;
